import { createContext, useContext, useState, useRef, useEffect, useCallback } from "react";

const Ctx = createContext(null);

export function AskSpotterProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [product, setProduct] = useState(null); // { id, title } when scoped to a product
  const [scopeSeq, setScopeSeq] = useState(0);   // bumps when the scope target changes
  const productRef = useRef(null);
  useEffect(() => { productRef.current = product; }, [product]);

  const openFor = useCallback((prod) => {
    const nextId = prod?.id || null;
    if ((productRef.current?.id || null) !== nextId) setScopeSeq((s) => s + 1);
    setProduct(prod || null);
    setOpen(true);
  }, []);

  const openGeneral = useCallback(() => {
    if (productRef.current) setScopeSeq((s) => s + 1);
    setProduct(null);
    setOpen(true);
  }, []);

  return (
    <Ctx.Provider value={{ open, setOpen, product, scopeSeq, openFor, openGeneral }}>
      {children}
    </Ctx.Provider>
  );
}

export const useAskSpotter = () => useContext(Ctx);
